// extracted by mini-css-extract-plugin
export default {"root":"changePassword_root__NdTwl"};